/* ============================================
   DEAN SUPPLY — BOOST AI CUSTOMIZATION
   boost-sd-custom.js
   
   Injects "Sold As" metafield badge into
   Instant Search Widget product results
   ============================================ */

(function() {
  var cache = {};

  function addBadge(container, soldAs) {
    if (container.querySelector('.dean-sold-as')) return;
    var badge = document.createElement('span');
    badge.className = 'dean-sold-as';
    badge.textContent = soldAs;
    badge.style.cssText =
      'display:inline-block;font-size:10px;font-weight:600;color:#b8976a;' +
      'background:rgba(212,175,110,0.1);padding:2px 6px;border-radius:3px;' +
      'margin-top:3px;letter-spacing:0.3px;font-family:DM Sans,sans-serif;';
    container.appendChild(badge);
  }

  function processItems() {
    var items = document.querySelectorAll('[class*="boost-sd__suggestion-queries-item"][class*="product"]');

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item.getAttribute('data-dean-sold-as')) continue;
      item.setAttribute('data-dean-sold-as', 'processing');

      var link = item.querySelector('a[href*="/products/"]');
      if (!link) { item.setAttribute('data-dean-sold-as', 'no-link'); continue; }

      var match = link.getAttribute('href').match(/\/products\/([^?#]+)/);
      if (!match) { item.setAttribute('data-dean-sold-as', 'no-match'); continue; }

      var handle = match[1];
      var rightCol = item.querySelector('[class*="item-product--right"]');
      if (!rightCol) { item.setAttribute('data-dean-sold-as', 'no-col'); continue; }

      (function(h, col, el) {
        if (cache.hasOwnProperty(h)) {
          if (cache[h]) addBadge(col, cache[h]);
          el.setAttribute('data-dean-sold-as', 'done');
          return;
        }

        fetch('/products/' + h + '?view=metafield-sold-as')
          .then(function(r) { return r.text(); })
          .then(function(t) {
            var val = t.trim();
            if (!val || val.charAt(0) === '<') {
              cache[h] = null;
            } else {
              cache[h] = val;
              addBadge(col, val);
            }
            el.setAttribute('data-dean-sold-as', 'done');
          })
          .catch(function() {
            cache[h] = null;
            el.setAttribute('data-dean-sold-as', 'error');
          });
      })(handle, rightCol, item);
    }
  }

  // Run on any DOM change with debounce
  var timer;
  new MutationObserver(function() {
    clearTimeout(timer);
    timer = setTimeout(processItems, 300);
  }).observe(document.body, { childList: true, subtree: true });

  // Also poll every 2 seconds as backup
  setInterval(processItems, 2000);

  // Also run when search input changes
  document.addEventListener('input', function(e) {
    if (e.target && e.target.matches && e.target.matches('[class*="boost-sd"] input, input[class*="search"]')) {
      clearTimeout(timer);
      timer = setTimeout(processItems, 500);
    }
  }, true);
})();
